export default __webpack_public_path__ + "static/media/link_white.4eb46ae9.svg";